<template>
   <div>
      <article class="container pt-4 pb-4 page" v-if="post">
         <div class="category-top d-print-none">
            <div class="category font-weight-semibold text-uppercase">{{getArea}}</div>
         </div>
         <div class="row justify-content-between">
            <div class="col-12 col-md-7 primo-piano text-left d-flex flex-column">
               <h1 class="h2">
                  {{post.titolo}}
               </h1>
               <p class=" mb-auto">
                  {{post.indirizzo}}
               </p>
               <a class="pointer text-right pt-4 mt-auto" v-scroll-to="{el:'#main-content', offset: -268}">Continua a leggere</a>
               <div class="w-100 mt-auto">
                  <div class="row mt-4 justify-content-between">
                     <div class="col-12 col-md-5"><strong class="x-small font-weight-semibold">Data di pubblicazione</strong><br />{{post.modified}}</div>
                     <div class="col-12 col-md-5 mt-4 mt-md-0 d-print-none"><strong class="x-small font-weight-semibold"> Tempo di lettura </strong><br />{{post.timeRead}}</div>
                  </div>
               </div>
            </div>

            <div class="col-12 col-md-5 flex-column card-deck mx-0 d-print-none">
               <div class="mb-3">
                  <div class="dropdown d-inline">
                     <shareArea></shareArea>
                  </div>
                  <div class="dropdown d-inline">
                     <actionArea></actionArea>
                  </div>
                  <miniMenu v-if="post.maggioriInfo && post.maggioriInfo.length > 0" :minimenu="post.maggioriInfo" :area="post.titolo" :slug="post.slug"></miniMenu>
               </div>
              
               <div class="tags mt-auto mb-4 d-print-none" v-if="(post.argomenti != null && post.argomenti.length > 0) || (post.s3 && post.s3.length > 0)">
                  <h6 class="sr-only">Tag</h6>
                  <span v-if="post.argomenti  != null && post.argomenti.length > 0">
                     <argomento v-for="(argomento, val) in post.argomenti" :tag="argomento" :key="val"></argomento>
                  </span>
                  <span v-if="post.s3">
                     <argomento v-for="(argument) in getArgument(post.s3)" :key="argument.id" :tag="argument.nome" :linkHref="argument.linkUrl" />
                  </span>
               </div>
            </div>
         </div>

        <div style="height:480px; overflow:hidden;">
          <MapContainer :long="post.location.longitude" :lat="post.location.latitude" :company="post.titolo" :logo="post.image[0]"/>
        </div>

         <div class="border-top ">
            <div class="row">
               <div id="menu-sinistro" class="col-12 col-md-3 sidebar-wrapper it-line-right-side d-print-none">
                  <aside class="col-12">
                     <div class="sidebar-linklist-wrapper">
                        <div class="link-list-wrapper">
                           <h3 class="no_toc">Indice della pagina</h3>
                           <div class="menu-separatore"><div id="progressbar" class="bg-complementary"></div></div>
                           <ul id="lista-paragrafi" class="link-list collapse collapse show">
                              <li><a class="list-item" v-scroll-to="{el:'#main-content', offset: -108}">Inizio contenuto</a></li>
                              <li id="toc" v-html="toc"></li>
                              <li v-if="post.image.length > 0"><a class="list-item" v-scroll-to="{el:'#logo', offset: -126}">Logo</a></li>
                           </ul>
                        </div>
                     </div>
                  </aside>
               </div>
               <div id="main-content" class="col-12 col-md-9 col-lg-8 col-xl-7 py-3 pl-md-5">
                  <div id="mainArticle" class="text-serif">
                     <vue-markdown 
                     :table-class="`table table-striped`" 
                     :toc="true" 
                     :toc-anchor-link-class="`sr-only`" 
                     :tocId="'toc'" 
                     :tocFirstLevel="2" 
                     :toc-last-level="6"
                     v-on:toc-rendered="setTOC"
                     :source="post.corpo" />
                  </div>    
                  <section class="mt-5" id="logo" v-if="post.image != null && post.image.length > 0">
                     <h4>Logo</h4>
                     <figure>
                        <div class="img-wrapper"  style="height:480px; overflow:hidden;">
                           <img :alt="post.image[0].didascalia" :title="post.image[0].didascalia" :src="post.image[0]" />
                        </div>
                     </figure>
                  </section>

                  <section class="mt-5" id="galleria" v-if="post.immaginiList != null && post.immaginiList.length > 0">
                     <h4>Galleria immagini</h4>
                     <carousel :margin="20" >
                        <img src="https://placeimg.com/200/200/any?1">
                        <img src="https://placeimg.com/200/200/any?2">
                        <img src="https://placeimg.com/200/200/any?3">
                        <img src="https://placeimg.com/200/200/any?4">
                     </carousel>
                  </section>               
                  <section class="mt-5" id="documenti" v-if="post.listaDocumenti != null && post.listaDocumenti.length > 0">
                     <h4>Documenti</h4>
                     <linkBox v-for="item in post.listaDocumenti" :key="item.id" :id="item.documento[0]" :nome="item.titolo" :type="'doc'"></linkBox>
                  </section>   
                  <section class="mt-5" id="linkEsterni" v-if="post.linkEsterni != null && post.linkEsterni.length > 0">
                     <h4>Link</h4>
                     <linkBox v-for="item in post.linkEsterni" :key="item.id" :linkUrl="item.linkURL" :nome="item.linkTitolo"></linkBox>
                  </section>   
               </div>
            </div>
         </div>
      </article>

      <section class="collegati" v-if="relatedPosts">
         <div class="container pt-2 pb-4 px-0 px-md-3 pt-5">
            <h3>Contenuti correlati</h3>
            <div class="row">               
               <!-- Call cards -->                              
               <card-area v-for="(item) in relatedPosts" :key="`${item.id}`" :data="item" :area="item.area" :id="`${item.id}`" :noFooter="true">
                  <template v-slot:header>{{item.titolo}}</template>
                  {{item.breve}}
               </card-area>    
            </div>
         </div>         
      </section>

      <section id="area-specializzazione" class="section section-inset-shadow pb-0 pt-0 pb-5" v-if="relatedAreas">
         <div id="content" class="container pt-2 pb-4 px-0 px-md-3 pt-5">
            <h3>Aree di Specializzazione</h3>
            <div class="row" v-if="relatedAreas">
               <imgcard v-for="(notizia) in relatedAreas" :key="notizia.id" :id="notizia.idContenuto" :articolo="notizia"/>               
            </div>
         </div>
      </section>   

   </div>
</template>
<script>
import { getPost, getPage, getDate, getAssociatedPostsIDs } from './../service';
import shareArea from "@/components/ShareArea";
import actionArea from "@/components/ActionArea";
import argomento from "@/components/Arguments.vue";
import linkBox from "@/components/LinkBox";
import carousel from 'vue-owl-carousel2';
import cardArea from "@/components/CardArea";
import miniMenu from "@/components/MiniMenu";
import MapContainer from "@/components/AppMap";
import VueMarkdown from 'vue-markdown';

export default {
   name: "post",
   components: {
      VueMarkdown,
      shareArea,
      actionArea,
      argomento,
      linkBox,
      carousel,
      cardArea,
      miniMenu,
      MapContainer
   },
   props:{
      type: {
         type: String,
         description: "Card type"
      },
      id: {
         type: String,
         description: "ID articolo"
      },     
      title: {
         type: String,
         description: "titolo articolo"
      },      
      area: {
         type: String,
         description: "titolo articolo"
      },                 
      slug: {
         type: String,
         description: "Slug"
      },
      _slug: {
         type: String,
         description: "Slug"
      },        
   },
   title() {
      let pageTitle = this.$route.params.title;
      return pageTitle;
   },
   data() {
      return {
         post: null,
         relatedPosts: null,
         relatedAreas: null,
         arguments: null,
         timeRead: 0,
         toc: ''
      }
   },
   methods: {
      loadPost: async function(id, schema) {
         this.post = undefined;        
         try {
            const result = await getPost(id, schema);
            this.post = this.parseArticle(result); 
            if(result.data.linkList != undefined  && result.data.linkList.iv.length > 0){
               this.relatedPosts = await this.loadRelatedPosts(result.data.linkList.iv);
            }
            if(this.post.areeSpecializzazione !== null && this.post.areeSpecializzazione.length > 0){
               console.log(result.data.areeSpecializzazione.iv);
               this.relatedAreas = await this.loadRelatedPosts(result.data.areeSpecializzazione.iv);
            }                             
         } catch (ex) {
            console.log('failed' + ex);
            this.post = null;
         }
      },

      loadPage: async function(id, schema) {
         this.post = undefined;
         try {
            const result = await getPage(id, schema);
            this.post = this.parseArticle(result);
            if(result.data.linkList != undefined && result.data.linkList.iv.length > 0){
               this.relatedPosts = await this.loadRelatedPosts(result.data.linkList.iv);
            }     
            if(this.post.areeSpecializzazione !== null && this.post.areeSpecializzazione.length > 0){
               console.log(result.data.areeSpecializzazione.iv);
               this.relatedAreas = await this.loadRelatedPosts(result.data.areeSpecializzazione.iv);
            }                
         } catch (ex) {
            console.log('failed' + ex);
            this.post = null;
         }
      },    

      loadRelatedPosts: async function(idArr){         
         try {
            let posts = await getAssociatedPostsIDs(idArr);
            return posts.posts;
         } catch (ex) {
            console.log('failed loadSubcategories');
         }
      },

      getArgument(id){
         return this.$root.getS3Category(id);
      },      

      parseArticle: function(response){
         this.$root.setTitle(response.data.titolo.iv);         
         
         return {
            id:                   response.id,
            modified:             getDate(response.lastModified),
            titolo:               response.data.titolo.iv,
            corpo:                (response.data.corpo ? response.data.corpo.iv : null),
            argomenti:            (response.data.argomenti ? response.data.argomenti.iv : null),
            image:                response.data.logo.iv,
            location:             (response.data.indirizzo ? response.data.indirizzo.iv : null),
            indirizzo:            (response.data.indirizzoTesto ? response.data.indirizzoTesto.iv : null),
            listaDocumenti:       (response.data.listaDocumenti ? response.data.listaDocumenti.iv : null),
            s3:                   (response.data.s3 ? response.data.s3.iv : null),
            areeSpecializzazione: (response.data.areeSpecializzazione !== undefined ? response.data.areeSpecializzazione.iv : null),
            schema:               (response.schemaDisplayName ? response.schemaDisplayName : null),
            slug:                 response.data.slug.iv,
            timeRead:             this.getTimeRead(response.data.tempoLettura.iv),
         }
      },      

      getTimeRead: function(text){
         let minutes = Math.ceil(text.split(" ").length / 130 );
         return minutes + " " + (minutes == 1 ? 'Minuto' : 'Minuti');
      },

      getSchema(){
         return 'partecipante';
      },

      setTOC(tocHtml){
         this.toc = tocHtml;
      },

   },

   created(){      
      let schema = this.getSchema();
      if(this.$route.params.id != undefined && this.$route.params.id != ''){
         this.loadPost(this.$route.params.id, schema);
      }
      else if(this.$route.params.slug && !this.$route.params._slug){
         this.loadPage(this.$route.params.slug, schema);
      }
      else{
         this.loadPage(this.$route.params._slug, schema);
      }      
   },
   
   computed:{
      getArea(){
         if(this.$route.params.area){
            return this.$route.params.area;
         }
         else{
            return this.post.schema;
         }
      }
   },   
   updated:function(){
      this.$nextTick(function(){
      })
   },
   watch: {
      $route: {
         handler: function(to) {
            this.loadPost(to.params.id, this.getSchema());            
         }
      }
   },   
};
</script>
<style>
   #galleria .owl-theme .owl-nav{ display:none !important; }
   #galleria .owl-dots{margin-top:20px;}
   #main-content .text-serif h4, #main-content .text-serif .h4 {font-family: "Titillium Web",Geneva,Tahoma,sans-serif; }
   #lista-paragrafi a, .pointer{cursor: pointer;}
</style>
